import { memo, useEffect } from 'react';
import { isEqual } from './isEqual';

function ArcReactivePropBase({
  accessor,
  property,
  value
}) {
  useEffect(() => {
    accessor.set(property, value);
  }, [accessor, property, value]);
  return null;
}
const ArcReactivePropMemo = memo(ArcReactivePropBase, isEqual);
const ArcReactiveProp = ArcReactivePropMemo;

export { ArcReactiveProp };
